const DOCUMENT_ITEM_TYPES = {
  livingWill: {
    id: 19,
    title: 'Living will',
    icon: 'bank-add',
    qaSelector: 'component-digital-vault_living-will',
  },
  powerOfAttorney: {
    id: 28,
    title: 'Power of attorney',
    icon: 'user-add',
    qaSelector: 'component-digital-vault_power-of-attorney',
  },
  lastWill: {
    id: 46,
    title: 'Last will and testament',
    icon: 'bank-acount-holder',
    qaSelector: 'component-digital-vault_last-will',
  },
  bankruptcyFiling: {
    id: 47,
    title: 'Bankruptcy filing',
    icon: 'bank-account-pending',
    qaSelector: 'component-digital-vault_bankruptcy',
  },
  courtDocument: {
    id: 48,
    title: 'Court document',
    icon: 'gavel',
    qaSelector: 'component-digital-vault_court-doc',
  },
  divorceAgreement: {
    id: 49,
    title: 'Divorce agreement',
    icon: 'address-change',
    qaSelector: 'component-digital-vault_divorce',
  },
  generalContract: {
    id: 50,
    title: 'General contract',
    icon: 'document-user',
    qaSelector: 'component-digital-vault_general-contract',
  },
  proofOfPurchase: {
    id: 51,
    title: 'Proof of purchase',
    icon: 'cash',
    qaSelector: 'component-digital-vault_proof-of-purchase',
  },
  realEstateAgreement: {
    id: 52,
    title: 'Real estate agreement',
    icon: 'home-check',
    qaSelector: 'component-digital-vault_real-estate',
  },
  otherDocument: {
    id: 24,
    title: 'Other document',
    icon: 'document',
    qaSelector: 'component-digital-vault_other',
  },
};

export type DocumentItemKeyType = keyof typeof DOCUMENT_ITEM_TYPES;
export default DOCUMENT_ITEM_TYPES;
